import React, { useEffect, useState } from 'react';
import ProgressCircle from "./components/ProgressCircle"
// import Container from '../../../components/Container/Container';
import { ListItem } from '../atoms/listitem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import variables from '../atoms/variables.json';
import { TextInput } from './../atoms/textinput';
// import Alert from '@material-ui/lab/Alert';
import ToolTip from '../atoms/ToolTip';
import PropertyCard from '../atoms/PropertyCard';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { connect } from 'react-redux';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import Switch from '@material-ui/core/Switch';
import {
  CardWrapper,
  TlyfeSelector,
  LineSeperator,
  Heading,
  SubHeading,
  TlyfeButtonWrapper,
  FormContainer,
  RowContainer,
} from './style';
import { CardBox } from '../atoms/card';
import { Button } from '../atoms/button';
// import { alertActions, tenantActions } from '../../../_actions';
// import { generalService } from '../../../_services';
import ContactCard from '../atoms/contactCard';
import { useDispatch, useSelector } from 'react-redux';
import BackComponent from '../atoms/backComponent';
import BottomButton from '../atoms/bottomButton';
// import StringConstants from '../../../utils/constants';
// import TEANANT_ICON from './../../../assets/svgIcons/OpenFlo/Tenant.svg';
import OpenFlowModal from '../atoms/modal';
import moment from 'moment';
import SaveandContinueModal from '../atoms/SaveandContinueModal';
import { View } from 'react-native';
import drawerHoc from '../../../../components/drawerHOC/DrawerHOC';
import getPlatformType from '../../../../helpers/helpers';
import { tenantActions } from '../../redux/tenant.actions';
import STRINGS from '../../redux/strings';
import { TenantService } from '../../redux/tenant.service';
import { showErrorToast, showSuccesToast } from '../helpers';
import { navigate } from '../../../../navigation/RootNavigation';
import TenantListScreen from './components/tenantList';
import HorizontalTabSlider from './components/HorizontalTabSlider';
import TenantStatusTable from './TenantStatusTable';
import Dialog from '@material-ui/core/Dialog';
import DialogButton from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
const userModal = {
  first_name: '',
  last_name: '',
  email: '',
  contact_number: '',
  isLeadTeanant: null,
  opbrix_id: '',
  is_lead: false,
  tLyfeId: '',
  pincode: '',
  address: '',
};
const layoutType = getPlatformType();
const TeanantDetails = (props) => {
  const dispatch = useDispatch();
  const globalState = useSelector((state) => state?.tenant.flowIdInfo);
  const tenantsArry = useSelector((state) => state?.tenant?.flowIdInfo?.tenants);

  const [value, setValue] = React.useState(null);
  const [teanentDetails, setTeanentDetails] = React.useState(userModal);

  const [notifyTeanant, setNotifyTeanants] = React.useState(false);

  const [addedUsers, setAddedUsers] = React.useState([]);
  const [showAgain, setShowAgain] = React.useState(false);
  const [flow, setFlow] = React.useState({});
  const [checked, setChecked] = React.useState(false);
  const [isValidate, setIsValidate] = React.useState(false);
  const [is_show_tenant_popup, setIs_show_tenant_popup] = React.useState(true);
  const [addUser, setAddUser] = React.useState(null);
  const [flowId, setFlowId] = React.useState(null);
  const [confirm, setConfirm] = React.useState(false);
  const [deleteCardconfirm, setDeleteCardconfirm] = React.useState(false);
  const [mailToUpdateAsLead, setMailToUpdateAsLead] = React.useState('');
  const [idToDeleteTenant, setIdToDeleteTenant] = React.useState('');
  const [showWarningDialog, setShowWarningDialog] = React.useState('');
  const [nameError, setNameError] = React.useState('');
  const [editTeanantID, setEditTeanantID] = React.useState('');
  const [showSuccessModal, setSuccessModal] = React.useState(false);
  const [closePopup, setClosePopup] = React.useState(false);

  const modalGlobalObject = useSelector((state) => state?.tenant?.tenantDetails);
  const [modalState, setModalState] = React.useState({
    send_to_tenant: true,
  });

  useEffect(() => {
    if (modalGlobalObject) {
      setModalState({
        send_to_tenant: modalGlobalObject.send_to_tenant,
      });
    }
  }, [modalGlobalObject]);

  useEffect(() => {
    console.log(props)
    if (props?.route?.params?.id) {
      setFlowId(props?.route?.params?.id);
      fetchFlows()
    }
  }, [props?.route?.params?.id]);
  const fetchFlows = () => {
    dispatch(tenantActions.getFlowInfo(props?.route?.params?.id));
  }
  useEffect(() => {
    if (tenantsArry && tenantsArry?.length) {
      setAddedUsers(tenantsArry);
      setFlow(globalState);
      setIs_show_tenant_popup(globalState?.is_send_tenant_details);
    } else {
      setAddedUsers([]);
    }
  }, [tenantsArry]);

  useEffect(() => {
    setTeanentDetails({
      ...teanentDetails,
      is_lead: addedUsers.length > 0 ? false : true,
    });
  }, [addedUsers]);
  const [fieldsValue, setFieldValues] = useState({
    tLyfeId: '',
    //8MDZ62U55
  });

  const handleChangeForm = (e, name) => {
    setFieldValues({ ...fieldsValue, [e.target.name]: e.target.value });
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const handleChangeToggle = (event) => {
    setNotifyTeanants(!notifyTeanant);
  };
  const handleChangeLead = (event) => {
    setFieldValues({
      ...fieldsValue,
      is_lead: event.target.value == 'true' ? true : false,
    });
  };
  console.log("is_leadis_lead", fieldsValue)
  const searchTenant = async (searchObject) => {
    let filterString;
    let searchBytlifeId
    if (searchObject.hasOwnProperty('tlife')) {
      filterString = `tlife=${searchObject.tlife}`;
      searchBytlifeId = true;
    } else {
      filterString = `email=${searchObject.email}`;
      searchBytlifeId = false;
    }
    dispatch(tenantActions.getTenantByTlyfeId(fieldsValue.tLyfeId.trim(), (response) => {
      if (response.status) {
        let data = response?.data?.user;
        setFieldValues({
          ...fieldsValue,
          title: data?.title,
          first_name: data?.first_name,
          last_name: data?.last_name,
          email: data?.email,
          confirm_email: data?.email,
          contact_number: data?.contact_number,
          isLeadTeanant: null,
          opbrix_id: response?.opbrix_id,
          postcode: data?.postcode,
          address: data?.address,
        });
      }
    }))
  }


  const MakeLeadFunct = (arrayData, emailTomakeLead) => {
    const data = arrayData.map((elem) => ({
      ...elem,
      is_lead2: emailTomakeLead === elem?.email ? true : false,
    }));
    return data;
  };

  const renderModalBody = (data, index) => (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
      }}
    >
      {data?.opbrix_id && (
        <TextInput
          title={
            <>
              <strong>tlyfe ID: </strong>
            </>
          }
          type={'row'}
          wrapperstyle={{
            width: '99%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={data?.opbrix_id || ''}
        />
      )}
      <TextInput
        title={
          <>
            <strong>Title: </strong>
          </>
        }
        type={'row'}
        wrapperstyle={{
          width: '10%',
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={data.title || ''}
      />
      <TextInput
        title={
          <>
            <strong>First Name: </strong>
          </>
        }
        type={'row'}
        wrapperstyle={{
          width: '38%',
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={data.first_name || ''}
      />
      <TextInput
        title={
          <>
            <strong>Last Name: </strong>
          </>
        }
        type={'row'}
        wrapperstyle={{
          width: '49%',
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={data.last_name || ''}
      />
      <TextInput
        title={
          <>
            <strong>Email: </strong>
          </>
        }
        type={'row'}
        wrapperstyle={{
          width: '49%',
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={data.email || ''}
      />
      <TextInput
        title={
          <>
            <strong>Contact Number: </strong>
          </>
        }
        type={'row'}
        wrapperstyle={{
          width: '49%',
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={data.contact_number || ''}
        onChange={(event) => {
          let teampArr = [...addedUsers];
          teampArr[index].contact_number = event.target.value.replace(/\D/, '');
          setAddUser(teampArr);
        }}
      />
      <TextInput
        title={
          <>
            <strong>Post Code: </strong>
          </>
        }
        type={'row'}
        wrapperstyle={{
          width: '49%',
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={data.postcode || ''}
        onChange={(event) => {
          let teampArr = [...addedUsers];
          teampArr[index].postcode = event.target.value;
          setAddUser(teampArr);
          console.log('teampArrteampArr', teampArr);
        }}
      />
      <TextInput
        title={
          <>
            <strong>Address: </strong>
          </>
        }
        type={'row'}
        wrapperstyle={{
          width: '49%',
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={data.address || ''}
        onChange={(event) => {
          let teampArr = [...addedUsers];
          teampArr[index].address = event.target.value;
          setAddUser(teampArr);
          console.log('teampArrteampArr', teampArr);
        }}
      />

      <Button
        style={{ marginTop: 20, marginBottom: 10, borderColor: '#90C418' }}
        onClick={() => {

          if (editTeanantID === data?.opbrix_id) {
            // dispatch(
            //   tenantActions.saveTeanantDetails(
            //     { tenants: addedUsers, is_show_tenant_popup: is_show_tenant_popup },
            //     flowId
            //   )
            // );
          } else {
            setEditTeanantID(data?.opbrix_id);
          }
        }}
        title={editTeanantID === data?.opbrix_id ? 'Save tenant' : 'Edit tenant'}
        type="stripe"
      />
    </div>
  );

  const renderMakeLeadModalBody = () => (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
      }}
    >
      <span>Do you wish to make this tenant as Lead Tenent</span>
      <br />
      <br />
      <TlyfeButtonWrapper style={{ justifyContent: 'space-between' }}>
        <Button
          onClick={() => {
            setClosePopup(false);
            setAddedUsers(MakeLeadFunct(addedUsers, mailToUpdateAsLead));
            // setConfirm(true)
          }}
          title={'Yes'}
          type="stripe"
          style={{ borderColor: '#90C418', color: '#90C418' }}
        />
        &nbsp;&nbsp;
        <Button
          onClick={() => {
            setClosePopup(false);
          }}
          title={'No'}
          type="stripe"
          style={{ borderColor: '#FC4850', color: '#FC4850' }}
        />
      </TlyfeButtonWrapper>
      <br /> <br />
      <RowContainer>
        <span>Please Note</span>
        <span>
          If you make tenent the Lead Tenant any other tenant has been assigned as lead tenant would no longer be the
          Lead Tenant
        </span>
      </RowContainer>
    </div>
  );

  const renderSuccessBody = () => (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
      }}
    >
      <span>
        Congratulations.
        <br />
        <br />
        You have added your tenant(s) to this onboard process.
        <br />
        <br />
      </span>

      <span>Tenants will be emailed directly to sign up to tlyfe and continue the move in process.</span>

      <div
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          marginTop: 20,
          marginBottom: 20,
          width: '100%',
        }}
      >
        <div
          style={{
            color: notifyTeanant ? '#dadada' : '#FC4850',
            fontWeight: '900',
            fontSize: 20,
            marginRight: 20,
          }}
        >
          Dont Send
        </div>

        <Switch
          checked={notifyTeanant}
          onChange={handleChangeToggle}
          name="notifyTeanant"
          color="primary"
          size="normal"
        />

        <div
          style={{
            color: notifyTeanant ? '#90C418' : '#dadada',
            fontWeight: '900',
            fontSize: 20,
            marginLeft: 20,
          }}
        >
          Send
        </div>
      </div>

      <div>PLEASE NOTE:</div>
      <span>
        The email may end up in your tenant(s) junk mail. Please communicate with them to ensure they locate the email
        and carry out the relevant actions.
      </span>
      <RowContainer style={{ display: 'flex', alignItems: 'center', marginTop: 20 }}>
        <Checkbox
          name="showPopup"
          checked={!is_show_tenant_popup}
          onChange={() => setIs_show_tenant_popup(!is_show_tenant_popup)}
          value={1}
          color="primary"
        />
        <span style={{ color: 'black' }}>Do not show again</span>
      </RowContainer>

      <div
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-evenly',
          alignItems: 'space-between',
        }}
      >
        <Button
          onClick={() => {
            setSuccessModal(false);
          }}
          style={{ borderColor: '#90C418', color: '#90C418' }}
          title={'Cancel'}
          type="stripe"
        />
        <Button
          onClick={() => {
            // dispatch(tenantActions.showPopup(showAgain));
            // dispatch(
            //   tenantActions.saveTeanantDetails(
            //     {
            //       tenants: addedUsers,
            //       is_show_tenant_popup: is_show_tenant_popup,
            //       notifyTeanant: notifyTeanant,
            //     },
            //     flowId
            //   )
            // );
            setSuccessModal(false);
            // setConfirm(true)
          }}
          style={{ borderColor: '#FC4850', color: '#FC4850' }}
          title={'OK'}
          type="stripe"
        />
      </div>
    </div>
  );

  const renderRemoveCardBody = (item, index) => (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
      }}
    >
      <span>Do you wish to remove this ?</span>
      <br />
      <br />
      <TlyfeButtonWrapper>
        <Button
          onClick={() => {
            let newArray = [...addedUsers];
            newArray.splice(index, 1);
            setAddedUsers(newArray);
            setClosePopup(false);
          }}
          title={'Yes'}
          type="stripe"
        />
        &nbsp;&nbsp;
        <Button
          onClick={() => {
            setClosePopup(false);
          }}
          title={'No'}
          type="stripe"
        />
      </TlyfeButtonWrapper>
      <br /> <br />
      <RowContainer>
        <span>Please Note</span>
        <span> Once you remove this you cannot undo this change</span>
      </RowContainer>
    </div>
  );
  const toggleLead = (arr, index) => {
    return arr.map((item, i) => ({
      ...item,
      is_lead: i === index ? true : false
    }));
  };
  const deleteFlow = (arr, index) => {
    return arr.map((item, i) => ({
      ...item,
      remove_from_flow: i === index ? true : false
    }));
  };

  return (
    <View style={{ flex: 1 }}>
      <CardWrapper>
        <ProgressCircle props={props} />

        {/* <ListItem
          type={'complete'}
          title={'Tenant'}
          description={`Begin the tenant onboarding process by "pairing" your Applicant Tenant(s) to your property.
              <br/><br/>
              OpenFlo interacts with TLyfe and it is recommended that you request that the Applicant Tenant(s) registers with TLyfe before you start this process in order to maximise process efficiency.`}
          showPropertyCard
        // icon={TEANANT_ICON}
        /> */}

        {/* <BackComponent id={flowId} isComplete={flow?.tenancy_status === 1 ? true : false} flowtype={'tenancy_status'} /> */}

        {/*           
        <div style={{ position: 'relative' }}>
          <ToolTip
            style={{ top: '0%', right: '-29%' }}
            heading={'Tool Tips'}
            ContentData={[
              'Ask the applicants to check if all the details are entered correctly via the tlyfe app.',
              'They are automatically sent a registration email if you include their email address in the tenant section.',
            ]}
          />
        </div> */}
        <BackComponent
          id={flowId}
          isComplete={globalState?.tenancy_status === 1 ? true : false}
          flowtype="tenancy_status"
        />
        <TenantListScreen
          flowId={flowId}
          addedUsers={addedUsers}
          onDelete={(index) => {
            console.log("index", index)
            dispatch(tenantActions.deleteUser(addedUsers[index].open_flow_sub_tenant_id, (data) => {
              showSuccesToast("Tenant deleted successfully!")
              fetchFlows()
            }, false, flowId))
          }}
          onMakeLead={(index) => {
            dispatch(tenantActions.makeLead(addedUsers[index].open_flow_sub_tenant_id, (data) => {
              showSuccesToast("Tenant marked as lead successfully!")
              fetchFlows()
            }, false, flowId))
          }}
        />
        <TenantStatusTable flowId={flowId} tenants={addedUsers} />
        {addedUsers && addedUsers.length ? (
          <BottomButton
            buttonText={'Send'}
            onRightClick={() => {
              setShowWarningDialog(true)
            }}

          />
        ) : null}

      </CardWrapper>
      <div>
        <Dialog
          open={showWarningDialog}
          onClose={() => { setShowWarningDialog(false) }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Are you sure?
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              This information will now be sent to your tenant(s). If you do not wish to do so. Please click Cancel.            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <DialogButton
              type='stripe'
              onClick={() => {
                setShowWarningDialog(false)
              }} color="primary">
              Cancel
            </DialogButton>
            <DialogButton onClick={() => {
              dispatch(tenantActions.sendTeanantDetails({
                tenants: addedUsers,
                flow_id: flowId,
                send_to_tenant: true
              }, (data) => {
                showSuccesToast("Request send successfully!")
                setShowWarningDialog(false)
              }))
            }} color="primary">
              Ok
            </DialogButton>
          </DialogActions>
        </Dialog>
      </div>
      <SaveandContinueModal
        visible={showSuccessModal}
        modalState={modalState}
        heading={'Tenant(s)'}
        subHeading={[
          'Congratulations.',
          'You have added your tenant(s) to this onboard process.',
          'Tenant(s) will be emailed directly to sign up to tlyfe and continue the move in process.',
          `If you toggle "send" your tenants will be notified  via email and app,`,
        ]}
        onCancelPress={() => setSuccessModal(false)}
        showNote
        onOkPress={(data) => {
          // dispatch(tenantActions.saveTeanantDetails({ tenants: addedUsers, ...data }, flowId));
        }}
      />
    </View>
  );
};
export default drawerHoc({
  Component: TeanantDetails,
  showBackButton: true,
  backNavigation: "CurrentOnboards",
});
